export const CUSTOM_EVENT_DYNAMIC_EVENT = 'dynamic-event';
